<template>
  <div>
    <span> {{ $t('Tenders.SelectAdditionalCategories') }} </span>
    <CategoriesList
      v-if="categories.length"
      :categories="categories"
      class="categories-list"
      :clear-selecting="deleteFromSelected"
      item_key="id"
      item_name="title"
      :model.sync="categories"
      multiple/>
    <CategoryDropdownTree
      class="v-input"
      :label="$t('Tenders.Category')"
      :max-multiple-count="$can('set', 'useClassificationTemplates') ? null : 5"
      :model.sync="categories"
      multiple
      :used="used"/>
  </div>
</template>

<script>
import CategoriesList from 'components/tenders/CategoriesList.vue'
import CategoryDropdownTree from 'components/common/dialogs/CategoryDropDownTree.vue'

export default {
  name: 'addAdditionalCategories',
  props: {
    additional_categories: Array,
    used: String
  },
  computed: {
    categories: {
      get() {
        return this.additional_categories
      },
      set(value) {
        this.$emit('update:additional_categories', value)
      }
    },
  },
  methods: {
    deleteFromSelected(item) {
      this.$set(this,'categories', this.categories.filter(el => el.id != item.id))
    },
  },
  components: {
    CategoriesList,
    CategoryDropdownTree
  }
}
</script>
<style lang="scss" scoped>
.categories-list {
  max-height: 300px;
  overflow: auto;
}
</style>
